import React, { useEffect, useRef, useState } from 'react';
import MonthlyChart from './MonthlyChart';
import VesselSummary from './VesselSummary';
import VesselProperties from './VesselProperties';
import { IValueVessel, TVesselMsiValue } from '../valueTypes';

export interface IVesselOverviewProps {
	vesselMsiValue: TVesselMsiValue | null;
	vessel: IValueVessel;
}

const VesselOverview: React.FC<IVesselOverviewProps> = ({ vesselMsiValue, vessel }) => {
	const ref = useRef<HTMLDivElement>(null);

	const [panelOffset, setPanelOffset] = useState<{ top: number; left: number }>();

	useEffect(() => {
		const updatePanelSize = () => {
			if (ref.current) {
				const { offsetTop, offsetLeft } = ref.current;
				setPanelOffset({ top: offsetTop, left: offsetLeft });
			}
		};

		// Initial measurement
		updatePanelSize();

		// Update on window resize
		window.addEventListener('resize', updatePanelSize);
		return () => {
			window.removeEventListener('resize', updatePanelSize);
		};
	}, []);

	return (
		<div className="flex flex-col w-full gap-4">
			<div ref={ref} className="flex w-full flex-row gap-4 items-stretch">
				{vesselMsiValue?.summary && (
					<div
						className={`flex-auto ${
							(vesselMsiValue?.monthlyChart && vesselMsiValue?.monthlyChart.chartDataItemList && 'w-auto') || 'w-full'
						}`}
					>
						<VesselSummary summary={vesselMsiValue.summary} />
					</div>
				)}
				{vesselMsiValue?.monthlyChart && vesselMsiValue?.monthlyChart.chartDataItemList && (
					<div className="flex-auto w-4/12">
						<MonthlyChart monthlyChart={vesselMsiValue.monthlyChart} panelOffset={panelOffset} />
					</div>
				)}
				<div
					className={`flex-auto ${
						(vesselMsiValue?.monthlyChart && vesselMsiValue?.monthlyChart.chartDataItemList && 'w-auto') || 'w-full'
					}`}
				>
					<VesselProperties vessel={vessel} />
				</div>
			</div>
		</div>
	);
};

export default VesselOverview;
